export const SEND_MESSAGE = 'contact/SEND_MESSAGE'
export const SET_SENT_MESSAGE_STATUS = 'contact/SET_SENT_MESSAGE_STATUS'
